import React from 'react';
import PropTypes from 'prop-types';
import Grid from '../../../../components/Grid/Grid';
import Typography from '../../../../components/Typography/Typography';

const CreatePilotTransferConfirmForm = ({ formData }) => (
  <Grid container direction="column" gap={0.5} sx={{ py: 1 }}>
    <Typography variant="subtitle1">
      所選材質為：<strong>{formData.materialName}</strong>
    </Typography>
    <Typography variant="subtitle1">
      原移轉單材質為：<strong>{formData.originalMaterialName}</strong>
    </Typography>
    <Typography variant="subtitle1">請確認是否仍要建立試燒單？</Typography>
  </Grid>
);

CreatePilotTransferConfirmForm.propTypes = {
  formData: PropTypes.shape({
    originalMaterialName: PropTypes.string.isRequired,
    materialName: PropTypes.string.isRequired,
    pilotTransferQty: PropTypes.string.isRequired,
    machineId: PropTypes.string.isRequired,
    isPQCPilot: PropTypes.bool.isRequired,
  }).isRequired,
};

export default CreatePilotTransferConfirmForm;
